import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SideMenuMobile from './SideMenuMobile';
import MenuButton from './MenuButton';
import ThemeToggle from './ThemeToggle';
import LiveClock from './LiveClock';

const Toolbar = styled(MuiToolbar)({
  width: '100%',
  padding: '8px 10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'center',
  gap: '8px',
  flexShrink: 0,
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'auto', md: 'none' },
        boxShadow: 0,
        bgcolor: 'background.paper',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar variant="regular">
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            flexGrow: 1,
            width: '100%',
            gap: 1,
          }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mr: 'auto', minWidth: 0 }}>
            <CustomIcon />
            <Typography
              component="h1"
              sx={{
                color: 'text.primary',
                fontSize: { xs: 15, sm: 18 },
                fontWeight: 900,
                lineHeight: 1.1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              Optibox
            </Typography>
          </Stack>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <LiveClock />
          </Box>
          <ThemeToggle />
          <MenuButton aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function CustomIcon() {
  return (
    <Box
      sx={{
        width: '1.7rem',
        height: '1.7rem',
        bgcolor: 'rgba(255,255,255,0.94)',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src="/optibox-logo.svg"
        alt="Optibox"
        sx={{ width: '1.35rem', height: '1.35rem', objectFit: 'contain' }}
      />
    </Box>
  );
}
